import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { CreateContact, EditContact } from "../../../ContactData.ts";

import { toast } from "react-toastify";
import Chip from "@mui/material/Chip";

// Country codes data (same as WhatsApp)
const countryCodes = [
  { code: "+216", country: "Tunisia", flag: "https://flagcdn.com/w20/tn.png" },
  { code: "+93", country: "Afghanistan", flag: "https://flagcdn.com/w20/af.png" },
  { code: "+355", country: "Albania", flag: "https://flagcdn.com/w20/al.png" },
  { code: "+213", country: "Algeria", flag: "https://flagcdn.com/w20/dz.png" },
  { code: "+376", country: "Andorra", flag: "https://flagcdn.com/w20/ad.png" },
  { code: "+244", country: "Angola", flag: "https://flagcdn.com/w20/ao.png" },
  { code: "+1", country: "Antigua and Barbuda", flag: "https://flagcdn.com/w20/ag.png" },
  { code: "+54", country: "Argentina", flag: "https://flagcdn.com/w20/ar.png" },
  { code: "+374", country: "Armenia", flag: "https://flagcdn.com/w20/am.png" },
  { code: "+61", country: "Australia", flag: "https://flagcdn.com/w20/au.png" },
  { code: "+43", country: "Austria", flag: "https://flagcdn.com/w20/at.png" },
  { code: "+994", country: "Azerbaijan", flag: "https://flagcdn.com/w20/az.png" },
  { code: "+1", country: "Bahamas", flag: "https://flagcdn.com/w20/bs.png" },
  { code: "+973", country: "Bahrain", flag: "https://flagcdn.com/w20/bh.png" },
  { code: "+880", country: "Bangladesh", flag: "https://flagcdn.com/w20/bd.png" },
  { code: "+1", country: "Barbados", flag: "https://flagcdn.com/w20/bb.png" },
  { code: "+375", country: "Belarus", flag: "https://flagcdn.com/w20/by.png" },
  { code: "+32", country: "Belgium", flag: "https://flagcdn.com/w20/be.png" },
  { code: "+501", country: "Belize", flag: "https://flagcdn.com/w20/bz.png" },
  { code: "+229", country: "Benin", flag: "https://flagcdn.com/w20/bj.png" },
  { code: "+975", country: "Bhutan", flag: "https://flagcdn.com/w20/bt.png" },
  { code: "+591", country: "Bolivia", flag: "https://flagcdn.com/w20/bo.png" },
  { code: "+387", country: "Bosnia and Herzegovina", flag: "https://flagcdn.com/w20/ba.png" },
  { code: "+267", country: "Botswana", flag: "https://flagcdn.com/w20/bw.png" },
  { code: "+55", country: "Brazil", flag: "https://flagcdn.com/w20/br.png" },
  { code: "+673", country: "Brunei", flag: "https://flagcdn.com/w20/bn.png" },
  { code: "+359", country: "Bulgaria", flag: "https://flagcdn.com/w20/bg.png" },
  { code: "+226", country: "Burkina Faso", flag: "https://flagcdn.com/w20/bf.png" },
  { code: "+257", country: "Burundi", flag: "https://flagcdn.com/w20/bi.png" },
  { code: "+855", country: "Cambodia", flag: "https://flagcdn.com/w20/kh.png" },
  { code: "+237", country: "Cameroon", flag: "https://flagcdn.com/w20/cm.png" },
  { code: "+1", country: "Canada", flag: "https://flagcdn.com/w20/ca.png" },
  { code: "+238", country: "Cape Verde", flag: "https://flagcdn.com/w20/cv.png" },
  { code: "+236", country: "Central African Republic", flag: "https://flagcdn.com/w20/cf.png" },
  { code: "+235", country: "Chad", flag: "https://flagcdn.com/w20/td.png" },
  { code: "+56", country: "Chile", flag: "https://flagcdn.com/w20/cl.png" },
  { code: "+86", country: "China", flag: "https://flagcdn.com/w20/cn.png" },
  { code: "+57", country: "Colombia", flag: "https://flagcdn.com/w20/co.png" },
  { code: "+269", country: "Comoros", flag: "https://flagcdn.com/w20/km.png" },
  { code: "+242", country: "Congo (Brazzaville)", flag: "https://flagcdn.com/w20/cg.png" },
  { code: "+243", country: "Congo (Kinshasa)", flag: "https://flagcdn.com/w20/cd.png" },
  { code: "+506", country: "Costa Rica", flag: "https://flagcdn.com/w20/cr.png" },
  { code: "+385", country: "Croatia", flag: "https://flagcdn.com/w20/hr.png" },
  { code: "+53", country: "Cuba", flag: "https://flagcdn.com/w20/cu.png" },
  { code: "+357", country: "Cyprus", flag: "https://flagcdn.com/w20/cy.png" },
  { code: "+420", country: "Czech Republic", flag: "https://flagcdn.com/w20/cz.png" },
  { code: "+45", country: "Denmark", flag: "https://flagcdn.com/w20/dk.png" },
  { code: "+253", country: "Djibouti", flag: "https://flagcdn.com/w20/dj.png" },
  { code: "+1", country: "Dominica", flag: "https://flagcdn.com/w20/dm.png" },
  { code: "+1", country: "Dominican Republic", flag: "https://flagcdn.com/w20/do.png" },
  { code: "+670", country: "East Timor", flag: "https://flagcdn.com/w20/tl.png" },
  { code: "+593", country: "Ecuador", flag: "https://flagcdn.com/w20/ec.png" },
  { code: "+20", country: "Egypt", flag: "https://flagcdn.com/w20/eg.png" },
  { code: "+503", country: "El Salvador", flag: "https://flagcdn.com/w20/sv.png" },
  { code: "+240", country: "Equatorial Guinea", flag: "https://flagcdn.com/w20/gq.png" },
  { code: "+291", country: "Eritrea", flag: "https://flagcdn.com/w20/er.png" },
  { code: "+372", country: "Estonia", flag: "https://flagcdn.com/w20/ee.png" },
  { code: "+268", country: "Eswatini", flag: "https://flagcdn.com/w20/sz.png" },
  { code: "+251", country: "Ethiopia", flag: "https://flagcdn.com/w20/et.png" },
  { code: "+679", country: "Fiji", flag: "https://flagcdn.com/w20/fj.png" },
  { code: "+358", country: "Finland", flag: "https://flagcdn.com/w20/fi.png" },
  { code: "+33", country: "France", flag: "https://flagcdn.com/w20/fr.png" },
  { code: "+241", country: "Gabon", flag: "https://flagcdn.com/w20/ga.png" },
  { code: "+220", country: "Gambia", flag: "https://flagcdn.com/w20/gm.png" },
  { code: "+995", country: "Georgia", flag: "https://flagcdn.com/w20/ge.png" },
  { code: "+49", country: "Germany", flag: "https://flagcdn.com/w20/de.png" },
  { code: "+233", country: "Ghana", flag: "https://flagcdn.com/w20/gh.png" },
  { code: "+30", country: "Greece", flag: "https://flagcdn.com/w20/gr.png" },
  { code: "+1", country: "Grenada", flag: "https://flagcdn.com/w20/gd.png" },
  { code: "+502", country: "Guatemala", flag: "https://flagcdn.com/w20/gt.png" },
  { code: "+224", country: "Guinea", flag: "https://flagcdn.com/w20/gn.png" },
  { code: "+245", country: "Guinea-Bissau", flag: "https://flagcdn.com/w20/gw.png" },
  { code: "+592", country: "Guyana", flag: "https://flagcdn.com/w20/gy.png" },
  { code: "+509", country: "Haiti", flag: "https://flagcdn.com/w20/ht.png" },
  { code: "+504", country: "Honduras", flag: "https://flagcdn.com/w20/hn.png" },
  { code: "+36", country: "Hungary", flag: "https://flagcdn.com/w20/hu.png" },
  { code: "+354", country: "Iceland", flag: "https://flagcdn.com/w20/is.png" },
  { code: "+91", country: "India", flag: "https://flagcdn.com/w20/in.png" },
  { code: "+62", country: "Indonesia", flag: "https://flagcdn.com/w20/id.png" },
  { code: "+98", country: "Iran", flag: "https://flagcdn.com/w20/ir.png" },
  { code: "+964", country: "Iraq", flag: "https://flagcdn.com/w20/iq.png" },
  { code: "+353", country: "Ireland", flag: "https://flagcdn.com/w20/ie.png" },
  { code: "+39", country: "Italy", flag: "https://flagcdn.com/w20/it.png" },
  { code: "+225", country: "Ivory Coast", flag: "https://flagcdn.com/w20/ci.png" },
  { code: "+1", country: "Jamaica", flag: "https://flagcdn.com/w20/jm.png" },
  { code: "+81", country: "Japan", flag: "https://flagcdn.com/w20/jp.png" },
  { code: "+962", country: "Jordan", flag: "https://flagcdn.com/w20/jo.png" },
  { code: "+7", country: "Kazakhstan", flag: "https://flagcdn.com/w20/kz.png" },
  { code: "+254", country: "Kenya", flag: "https://flagcdn.com/w20/ke.png" },
  { code: "+686", country: "Kiribati", flag: "https://flagcdn.com/w20/ki.png" },
  { code: "+965", country: "Kuwait", flag: "https://flagcdn.com/w20/kw.png" },
  { code: "+996", country: "Kyrgyzstan", flag: "https://flagcdn.com/w20/kg.png" },
  { code: "+856", country: "Laos", flag: "https://flagcdn.com/w20/la.png" },
  { code: "+371", country: "Latvia", flag: "https://flagcdn.com/w20/lv.png" },
  { code: "+961", country: "Lebanon", flag: "https://flagcdn.com/w20/lb.png" },
  { code: "+266", country: "Lesotho", flag: "https://flagcdn.com/w20/ls.png" },
  { code: "+231", country: "Liberia", flag: "https://flagcdn.com/w20/lr.png" },
  { code: "+218", country: "Libya", flag: "https://flagcdn.com/w20/ly.png" },
  { code: "+423", country: "Liechtenstein", flag: "https://flagcdn.com/w20/li.png" },
  { code: "+370", country: "Lithuania", flag: "https://flagcdn.com/w20/lt.png" },
  { code: "+352", country: "Luxembourg", flag: "https://flagcdn.com/w20/lu.png" },
  { code: "+261", country: "Madagascar", flag: "https://flagcdn.com/w20/mg.png" },
  { code: "+265", country: "Malawi", flag: "https://flagcdn.com/w20/mw.png" },
  { code: "+60", country: "Malaysia", flag: "https://flagcdn.com/w20/my.png" },
  { code: "+960", country: "Maldives", flag: "https://flagcdn.com/w20/mv.png" },
  { code: "+223", country: "Mali", flag: "https://flagcdn.com/w20/ml.png" },
  { code: "+356", country: "Malta", flag: "https://flagcdn.com/w20/mt.png" },
  { code: "+692", country: "Marshall Islands", flag: "https://flagcdn.com/w20/mh.png" },
  { code: "+222", country: "Mauritania", flag: "https://flagcdn.com/w20/mr.png" },
  { code: "+230", country: "Mauritius", flag: "https://flagcdn.com/w20/mu.png" },
  { code: "+52", country: "Mexico", flag: "https://flagcdn.com/w20/mx.png" },
  { code: "+691", country: "Micronesia", flag: "https://flagcdn.com/w20/fm.png" },
  { code: "+373", country: "Moldova", flag: "https://flagcdn.com/w20/md.png" },
  { code: "+377", country: "Monaco", flag: "https://flagcdn.com/w20/mc.png" },
  { code: "+976", country: "Mongolia", flag: "https://flagcdn.com/w20/mn.png" },
  { code: "+382", country: "Montenegro", flag: "https://flagcdn.com/w20/me.png" },
  { code: "+212", country: "Morocco", flag: "https://flagcdn.com/w20/ma.png" },
  { code: "+258", country: "Mozambique", flag: "https://flagcdn.com/w20/mz.png" },
  { code: "+95", country: "Myanmar", flag: "https://flagcdn.com/w20/mm.png" },
  { code: "+264", country: "Namibia", flag: "https://flagcdn.com/w20/na.png" },
  { code: "+674", country: "Nauru", flag: "https://flagcdn.com/w20/nr.png" },
  { code: "+977", country: "Nepal", flag: "https://flagcdn.com/w20/np.png" },
  { code: "+31", country: "Netherlands", flag: "https://flagcdn.com/w20/nl.png" },
  { code: "+64", country: "New Zealand", flag: "https://flagcdn.com/w20/nz.png" },
  { code: "+505", country: "Nicaragua", flag: "https://flagcdn.com/w20/ni.png" },
  { code: "+227", country: "Niger", flag: "https://flagcdn.com/w20/ne.png" },
  { code: "+234", country: "Nigeria", flag: "https://flagcdn.com/w20/ng.png" },
  { code: "+850", country: "North Korea", flag: "https://flagcdn.com/w20/kp.png" },
  { code: "+389", country: "North Macedonia", flag: "https://flagcdn.com/w20/mk.png" },
  { code: "+47", country: "Norway", flag: "https://flagcdn.com/w20/no.png" },
  { code: "+968", country: "Oman", flag: "https://flagcdn.com/w20/om.png" },
  { code: "+92", country: "Pakistan", flag: "https://flagcdn.com/w20/pk.png" },
  { code: "+680", country: "Palau", flag: "https://flagcdn.com/w20/pw.png" },
  { code: "+970", country: "Palestine", flag: "https://flagcdn.com/w20/ps.png" },
  { code: "+507", country: "Panama", flag: "https://flagcdn.com/w20/pa.png" },
  { code: "+675", country: "Papua New Guinea", flag: "https://flagcdn.com/w20/pg.png" },
  { code: "+595", country: "Paraguay", flag: "https://flagcdn.com/w20/py.png" },
  { code: "+51", country: "Peru", flag: "https://flagcdn.com/w20/pe.png" },
  { code: "+63", country: "Philippines", flag: "https://flagcdn.com/w20/ph.png" },
  { code: "+48", country: "Poland", flag: "https://flagcdn.com/w20/pl.png" },
  { code: "+351", country: "Portugal", flag: "https://flagcdn.com/w20/pt.png" },
  { code: "+974", country: "Qatar", flag: "https://flagcdn.com/w20/qa.png" },
  { code: "+40", country: "Romania", flag: "https://flagcdn.com/w20/ro.png" },
  { code: "+7", country: "Russia", flag: "https://flagcdn.com/w20/ru.png" },
  { code: "+250", country: "Rwanda", flag: "https://flagcdn.com/w20/rw.png" },
  { code: "+1", country: "Saint Kitts and Nevis", flag: "https://flagcdn.com/w20/kn.png" },
  { code: "+1", country: "Saint Lucia", flag: "https://flagcdn.com/w20/lc.png" },
  { code: "+1", country: "Saint Vincent and the Grenadines", flag: "https://flagcdn.com/w20/vc.png" },
  { code: "+685", country: "Samoa", flag: "https://flagcdn.com/w20/ws.png" },
  { code: "+378", country: "San Marino", flag: "https://flagcdn.com/w20/sm.png" },
  { code: "+239", country: "Sao Tome and Principe", flag: "https://flagcdn.com/w20/st.png" },
  { code: "+966", country: "Saudi Arabia", flag: "https://flagcdn.com/w20/sa.png" },
  { code: "+221", country: "Senegal", flag: "https://flagcdn.com/w20/sn.png" },
  { code: "+381", country: "Serbia", flag: "https://flagcdn.com/w20/rs.png" },
  { code: "+248", country: "Seychelles", flag: "https://flagcdn.com/w20/sc.png" },
  { code: "+232", country: "Sierra Leone", flag: "https://flagcdn.com/w20/sl.png" },
  { code: "+65", country: "Singapore", flag: "https://flagcdn.com/w20/sg.png" },
  { code: "+421", country: "Slovakia", flag: "https://flagcdn.com/w20/sk.png" },
  { code: "+386", country: "Slovenia", flag: "https://flagcdn.com/w20/si.png" },
  { code: "+677", country: "Solomon Islands", flag: "https://flagcdn.com/w20/sb.png" },
  { code: "+252", country: "Somalia", flag: "https://flagcdn.com/w20/so.png" },
  { code: "+27", country: "South Africa", flag: "https://flagcdn.com/w20/za.png" },
  { code: "+82", country: "South Korea", flag: "https://flagcdn.com/w20/kr.png" },
  { code: "+211", country: "South Sudan", flag: "https://flagcdn.com/w20/ss.png" },
  { code: "+34", country: "Spain", flag: "https://flagcdn.com/w20/es.png" },
  { code: "+94", country: "Sri Lanka", flag: "https://flagcdn.com/w20/lk.png" },
  { code: "+249", country: "Sudan", flag: "https://flagcdn.com/w20/sd.png" },
  { code: "+597", country: "Suriname", flag: "https://flagcdn.com/w20/sr.png" },
  { code: "+46", country: "Sweden", flag: "https://flagcdn.com/w20/se.png" },
  { code: "+41", country: "Switzerland", flag: "https://flagcdn.com/w20/ch.png" },
  { code: "+963", country: "Syria", flag: "https://flagcdn.com/w20/sy.png" },
  { code: "+886", country: "Taiwan", flag: "https://flagcdn.com/w20/tw.png" },
  { code: "+992", country: "Tajikistan", flag: "https://flagcdn.com/w20/tj.png" },
  { code: "+255", country: "Tanzania", flag: "https://flagcdn.com/w20/tz.png" },
  { code: "+66", country: "Thailand", flag: "https://flagcdn.com/w20/th.png" },
  { code: "+228", country: "Togo", flag: "https://flagcdn.com/w20/tg.png" },
  { code: "+676", country: "Tonga", flag: "https://flagcdn.com/w20/to.png" },
  { code: "+1", country: "Trinidad and Tobago", flag: "https://flagcdn.com/w20/tt.png" },
  { code: "+90", country: "Turkey", flag: "https://flagcdn.com/w20/tr.png" },
  { code: "+993", country: "Turkmenistan", flag: "https://flagcdn.com/w20/tm.png" },
  { code: "+688", country: "Tuvalu", flag: "https://flagcdn.com/w20/tv.png" },
  { code: "+256", country: "Uganda", flag: "https://flagcdn.com/w20/ug.png" },
  { code: "+380", country: "Ukraine", flag: "https://flagcdn.com/w20/ua.png" },
  { code: "+971", country: "United Arab Emirates", flag: "https://flagcdn.com/w20/ae.png" },
  { code: "+44", country: "United Kingdom", flag: "https://flagcdn.com/w20/gb.png" },
  { code: "+1", country: "United States", flag: "https://flagcdn.com/w20/us.png" },
  { code: "+598", country: "Uruguay", flag: "https://flagcdn.com/w20/uy.png" },
  { code: "+998", country: "Uzbekistan", flag: "https://flagcdn.com/w20/uz.png" },
  { code: "+678", country: "Vanuatu", flag: "https://flagcdn.com/w20/vu.png" },
  { code: "+39", country: "Vatican City", flag: "https://flagcdn.com/w20/va.png" },
  { code: "+58", country: "Venezuela", flag: "https://flagcdn.com/w20/ve.png" },
  { code: "+84", country: "Vietnam", flag: "https://flagcdn.com/w20/vn.png" },
  { code: "+967", country: "Yemen", flag: "https://flagcdn.com/w20/ye.png" },
  { code: "+260", country: "Zambia", flag: "https://flagcdn.com/w20/zm.png" },
  { code: "+263", country: "Zimbabwe", flag: "https://flagcdn.com/w20/zw.png" }
];

const PhoneLinkDialog = ({
  setOpenPhoneDialog,
  openPhoneDialog,
  Id,
  editingContact = null,
  fetchProfile,
  clearEditingContact,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contactName, setContactName] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("+1");
  const [isLoading, setIsLoading] = useState(false);

  // Function to extract country code from a phone number
  const extractCountryCode = (phoneNumber) => {
    if (!phoneNumber || !phoneNumber.startsWith("+")) {
      return "+1"; // Default to US
    }

    // Sort country codes by length (longest first) to match correctly
    const sortedCodes = countryCodes
      .map((c) => c.code)
      .filter((code, index, arr) => arr.indexOf(code) === index) // Remove duplicates
      .sort((a, b) => b.length - a.length);

    for (const code of sortedCodes) {
      if (phoneNumber.startsWith(code)) {
        return code;
      }
    }

    return "+1"; // Default fallback
  };

  // Function to extract the number without country code
  const extractNumberWithoutCode = (phoneNumber, countryCode) => {
    if (!phoneNumber || !phoneNumber.startsWith(countryCode)) {
      return "";
    }
    return phoneNumber.substring(countryCode.length).replace(/^\s+/, "");
  };

  useEffect(() => {
    if (editingContact) {
      const fullNumber = editingContact.LinkUrl || "";
      const extractedCode = extractCountryCode(fullNumber);
      const numberWithoutCode = extractNumberWithoutCode(
        fullNumber,
        extractedCode
      );
      setSelectedCountryCode(extractedCode);
      setPhoneNumber(numberWithoutCode);
      setContactName(editingContact.Title || "");
    } else {
      setSelectedCountryCode("+1");
      setPhoneNumber("");
      setContactName("");
    }
  }, [editingContact, openPhoneDialog]);

  const handleContactNameChange = (event) => {
    setContactName(event.target.value);
  };

  const validatePhoneNumber = (countryCode, phoneNumber) => {
    if (!phoneNumber || phoneNumber.trim() === "") {
      return { isValid: false, error: "Phone number is required" };
    }

    if (!countryCode) {
      return { isValid: false, error: "Country code is required" };
    }

    // Remove all spaces, dashes, parentheses, and other formatting from phone number
    const cleanNumber = phoneNumber.replace(/[\s\-\(\)\.]/g, "");

    // Check if it contains only digits after cleaning
    if (!/^\d+$/.test(cleanNumber)) {
      return {
        isValid: false,
        error:
          "Phone number should contain only digits, spaces, dashes, or parentheses",
      };
    }

    // Country-specific validation patterns (same as WhatsApp)
    const countryValidation = {
  "+1": { minLength: 10, maxLength: 10, pattern: /^[2-9]\d{9}$/, errorMsg: "10 digits (US/Canada/Carib)" },
  "+7": { minLength: 10, maxLength: 10, pattern: /^[1-9]\d{9}$/, errorMsg: "10 digits (Russia/Kazakhstan)" },
  "+20": { minLength: 10, maxLength: 10, pattern: /^1\d{9}$/, errorMsg: "10 digits" },
  "+27": { minLength: 9, maxLength: 9, pattern: /^[6-8]\d{8}$/, errorMsg: "9 digits" },
  "+30": { minLength: 10, maxLength: 10, pattern: /^6\d{9}$/, errorMsg: "10 digits" },
  "+31": { minLength: 9, maxLength: 9, pattern: /^6\d{8}$/, errorMsg: "9 digits" },
  "+32": { minLength: 9, maxLength: 9, pattern: /^4\d{8}$/, errorMsg: "9 digits" },
  "+33": { minLength: 9, maxLength: 9, pattern: /^[6-7]\d{8}$/, errorMsg: "9 digits" },
  "+34": { minLength: 9, maxLength: 9, pattern: /^[6-7]\d{8}$/, errorMsg: "9 digits" },
  "+36": { minLength: 9, maxLength: 9, pattern: /^[237]\d{8}$/, errorMsg: "9 digits" },
  "+39": { minLength: 9, maxLength: 10, pattern: /^3\d{8,9}$/, errorMsg: "9-10 digits" },
  "+40": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+41": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+43": { minLength: 10, maxLength: 13, pattern: /^6\d{9,12}$/, errorMsg: "10-13 digits" },
  "+44": { minLength: 10, maxLength: 10, pattern: /^7\d{9}$/, errorMsg: "10 digits" },
  "+45": { minLength: 8, maxLength: 8, pattern: /^[2-9]\d{7}$/, errorMsg: "8 digits" },
  "+46": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+47": { minLength: 8, maxLength: 8, pattern: /^[49]\d{7}$/, errorMsg: "8 digits" },
  "+48": { minLength: 9, maxLength: 9, pattern: /^[4-8]\d{8}$/, errorMsg: "9 digits" },
  "+49": { minLength: 10, maxLength: 11, pattern: /^1\d{9,10}$/, errorMsg: "10-11 digits" },
  "+51": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+52": { minLength: 10, maxLength: 10, pattern: /^\d{10}$/, errorMsg: "10 digits" },
  "+53": { minLength: 8, maxLength: 8, pattern: /^5\d{7}$/, errorMsg: "8 digits" },
  "+54": { minLength: 10, maxLength: 10, pattern: /^\d{10}$/, errorMsg: "10 digits" },
  "+55": { minLength: 11, maxLength: 11, pattern: /^9\d{10}$/, errorMsg: "11 digits" },
  "+56": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+57": { minLength: 10, maxLength: 10, pattern: /^3\d{9}$/, errorMsg: "10 digits" },
  "+58": { minLength: 10, maxLength: 10, pattern: /^4\d{9}$/, errorMsg: "10 digits" },
  "+60": { minLength: 9, maxLength: 10, pattern: /^1\d{8,9}$/, errorMsg: "9-10 digits" },
  "+61": { minLength: 9, maxLength: 9, pattern: /^4\d{8}$/, errorMsg: "9 digits" },
  "+62": { minLength: 9, maxLength: 12, pattern: /^8\d{8,11}$/, errorMsg: "9-12 digits" },
  "+63": { minLength: 10, maxLength: 10, pattern: /^9\d{9}$/, errorMsg: "10 digits" },
  "+64": { minLength: 8, maxLength: 10, pattern: /^2\d{7,9}$/, errorMsg: "8-10 digits" },
  "+65": { minLength: 8, maxLength: 8, pattern: /^[89]\d{7}$/, errorMsg: "8 digits" },
  "+66": { minLength: 9, maxLength: 9, pattern: /^[689]\d{8}$/, errorMsg: "9 digits" },
  "+81": { minLength: 10, maxLength: 10, pattern: /^[789]0\d{8}$/, errorMsg: "10 digits" },
  "+82": { minLength: 9, maxLength: 10, pattern: /^1\d{8,9}$/, errorMsg: "9-10 digits" },
  "+84": { minLength: 9, maxLength: 9, pattern: /^[35789]\d{8}$/, errorMsg: "9 digits" },
  "+86": { minLength: 11, maxLength: 11, pattern: /^1\d{10}$/, errorMsg: "11 digits" },
  "+90": { minLength: 10, maxLength: 10, pattern: /^5\d{9}$/, errorMsg: "10 digits" },
  "+91": { minLength: 10, maxLength: 10, pattern: /^[6-9]\d{9}$/, errorMsg: "10 digits" },
  "+92": { minLength: 10, maxLength: 10, pattern: /^3\d{9}$/, errorMsg: "10 digits" },
  "+93": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+94": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+95": { minLength: 7, maxLength: 10, pattern: /^9\d{6,9}$/, errorMsg: "7-10 digits" },
  "+98": { minLength: 10, maxLength: 10, pattern: /^9\d{9}$/, errorMsg: "10 digits" },
  "+211": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+212": { minLength: 9, maxLength: 9, pattern: /^[67]\d{8}$/, errorMsg: "9 digits" },
  "+213": { minLength: 9, maxLength: 9, pattern: /^[5-7]\d{8}$/, errorMsg: "9 digits" },
  "+216": { minLength: 8, maxLength: 8, pattern: /^[2459]\d{7}$/, errorMsg: "8 digits" },
  "+218": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+220": { minLength: 7, maxLength: 7, pattern: /^[23679]\d{6}$/, errorMsg: "7 digits" },
  "+221": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+222": { minLength: 8, maxLength: 8, pattern: /^[234]\d{7}$/, errorMsg: "8 digits" },
  "+223": { minLength: 8, maxLength: 8, pattern: /^[5-9]\d{7}$/, errorMsg: "8 digits" },
  "+224": { minLength: 9, maxLength: 9, pattern: /^6\d{8}$/, errorMsg: "9 digits" },
  "+225": { minLength: 10, maxLength: 10, pattern: /^[0157]\d{9}$/, errorMsg: "10 digits" },
  "+226": { minLength: 8, maxLength: 8, pattern: /^[5-7]\d{7}$/, errorMsg: "8 digits" },
  "+227": { minLength: 8, maxLength: 8, pattern: /^[89]\d{7}$/, errorMsg: "8 digits" },
  "+228": { minLength: 8, maxLength: 8, pattern: /^9\d{7}$/, errorMsg: "8 digits" },
  "+229": { minLength: 8, maxLength: 8, pattern: /^[4569]\d{7}$/, errorMsg: "8 digits" },
  "+230": { minLength: 7, maxLength: 7, pattern: /^5\d{6}$/, errorMsg: "7 digits" },
  "+231": { minLength: 7, maxLength: 8, pattern: /^[5-8]\d{6,7}$/, errorMsg: "7-8 digits" },
  "+232": { minLength: 8, maxLength: 8, pattern: /^[237]\d{7}$/, errorMsg: "8 digits" },
  "+233": { minLength: 9, maxLength: 9, pattern: /^[25]\d{8}$/, errorMsg: "9 digits" },
  "+234": { minLength: 10, maxLength: 10, pattern: /^[789]\d{9}$/, errorMsg: "10 digits" },
  "+235": { minLength: 8, maxLength: 8, pattern: /^[679]\d{7}$/, errorMsg: "8 digits" },
  "+236": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+237": { minLength: 9, maxLength: 9, pattern: /^6\d{8}$/, errorMsg: "9 digits" },
  "+238": { minLength: 7, maxLength: 7, pattern: /^9\d{6}$/, errorMsg: "7 digits" },
  "+239": { minLength: 7, maxLength: 7, pattern: /^9\d{6}$/, errorMsg: "7 digits" },
  "+240": { minLength: 9, maxLength: 9, pattern: /^2\d{8}$/, errorMsg: "9 digits" },
  "+241": { minLength: 7, maxLength: 7, pattern: /^[067]\d{6}$/, errorMsg: "7 digits" },
  "+242": { minLength: 9, maxLength: 9, pattern: /^0\d{8}$/, errorMsg: "9 digits" },
  "+243": { minLength: 9, maxLength: 9, pattern: /^8\d{8}$/, errorMsg: "9 digits" },
  "+244": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+245": { minLength: 7, maxLength: 7, pattern: /^9\d{6}$/, errorMsg: "7 digits" },
  "+248": { minLength: 7, maxLength: 7, pattern: /^2\d{6}$/, errorMsg: "7 digits" },
  "+249": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+250": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+251": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+252": { minLength: 8, maxLength: 9, pattern: /^[69]\d{7,8}$/, errorMsg: "8-9 digits" },
  "+253": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+254": { minLength: 9, maxLength: 9, pattern: /^[17]\d{8}$/, errorMsg: "9 digits" },
  "+255": { minLength: 9, maxLength: 9, pattern: /^[67]\d{8}$/, errorMsg: "9 digits" },
  "+256": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+257": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+258": { minLength: 9, maxLength: 9, pattern: /^8\d{8}$/, errorMsg: "9 digits" },
  "+260": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+261": { minLength: 9, maxLength: 9, pattern: /^3\d{8}$/, errorMsg: "9 digits" },
  "+263": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+264": { minLength: 9, maxLength: 9, pattern: /^8\d{8}$/, errorMsg: "9 digits" },
  "+265": { minLength: 9, maxLength: 9, pattern: /^[89]\d{8}$/, errorMsg: "9 digits" },
  "+266": { minLength: 8, maxLength: 8, pattern: /^[56]\d{7}$/, errorMsg: "8 digits" },
  "+267": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+268": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+269": { minLength: 7, maxLength: 7, pattern: /^3\d{6}$/, errorMsg: "7 digits" },
  "+291": { minLength: 7, maxLength: 7, pattern: /^[17]\d{6}$/, errorMsg: "7 digits" },
  "+351": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+352": { minLength: 9, maxLength: 9, pattern: /^6\d{8}$/, errorMsg: "9 digits" },
  "+353": { minLength: 9, maxLength: 9, pattern: /^8\d{8}$/, errorMsg: "9 digits" },
  "+354": { minLength: 7, maxLength: 7, pattern: /^[6-8]\d{6}$/, errorMsg: "7 digits" },
  "+355": { minLength: 9, maxLength: 9, pattern: /^6\d{8}$/, errorMsg: "9 digits" },
  "+356": { minLength: 8, maxLength: 8, pattern: /^[79]\d{7}$/, errorMsg: "8 digits" },
  "+357": { minLength: 8, maxLength: 8, pattern: /^9\d{7}$/, errorMsg: "8 digits" },
  "+358": { minLength: 5, maxLength: 10, pattern: /^4\d{4,9}$/, errorMsg: "5-10 digits" },
  "+359": { minLength: 9, maxLength: 9, pattern: /^[89]\d{8}$/, errorMsg: "9 digits" },
  "+370": { minLength: 8, maxLength: 8, pattern: /^6\d{7}$/, errorMsg: "8 digits" },
  "+371": { minLength: 8, maxLength: 8, pattern: /^2\d{7}$/, errorMsg: "8 digits" },
  "+372": { minLength: 7, maxLength: 8, pattern: /^5\d{6,7}$/, errorMsg: "7-8 digits" },
  "+373": { minLength: 8, maxLength: 8, pattern: /^[67]\d{7}$/, errorMsg: "8 digits" },
  "+374": { minLength: 8, maxLength: 8, pattern: /^[345789]\d{7}$/, errorMsg: "8 digits" },
  "+375": { minLength: 9, maxLength: 9, pattern: /^[234]\d{8}$/, errorMsg: "9 digits" },
  "+376": { minLength: 6, maxLength: 6, pattern: /^[3-6]\d{5}$/, errorMsg: "6 digits" },
  "+377": { minLength: 8, maxLength: 9, pattern: /^[46]\d{7,8}$/, errorMsg: "8-9 digits" },
  "+378": { minLength: 6, maxLength: 10, pattern: /^6\d{5,9}$/, errorMsg: "6-10 digits" },
  "+380": { minLength: 9, maxLength: 9, pattern: /^[3-9]\d{8}$/, errorMsg: "9 digits" },
  "+381": { minLength: 8, maxLength: 9, pattern: /^6\d{7,8}$/, errorMsg: "8-9 digits" },
  "+382": { minLength: 8, maxLength: 8, pattern: /^6\d{7}$/, errorMsg: "8 digits" },
  "+385": { minLength: 8, maxLength: 9, pattern: /^9\d{7,8}$/, errorMsg: "8-9 digits" },
  "+386": { minLength: 8, maxLength: 8, pattern: /^[3-7]\d{7}$/, errorMsg: "8 digits" },
  "+387": { minLength: 8, maxLength: 8, pattern: /^6\d{7}$/, errorMsg: "8 digits" },
  "+389": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+420": { minLength: 9, maxLength: 9, pattern: /^[67]\d{8}$/, errorMsg: "9 digits" },
  "+421": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+423": { minLength: 7, maxLength: 7, pattern: /^7\d{6}$/, errorMsg: "7 digits" },
  "+501": { minLength: 7, maxLength: 7, pattern: /^6\d{6}$/, errorMsg: "7 digits" },
  "+502": { minLength: 8, maxLength: 8, pattern: /^[345]\d{7}$/, errorMsg: "8 digits" },
  "+503": { minLength: 8, maxLength: 8, pattern: /^[67]\d{7}$/, errorMsg: "8 digits" },
  "+504": { minLength: 8, maxLength: 8, pattern: /^[389]\d{7}$/, errorMsg: "8 digits" },
  "+505": { minLength: 8, maxLength: 8, pattern: /^[5678]\d{7}$/, errorMsg: "8 digits" },
  "+506": { minLength: 8, maxLength: 8, pattern: /^[5-8]\d{7}$/, errorMsg: "8 digits" },
  "+507": { minLength: 8, maxLength: 8, pattern: /^6\d{7}$/, errorMsg: "8 digits" },
  "+509": { minLength: 8, maxLength: 8, pattern: /^[34]\d{7}$/, errorMsg: "8 digits" },
  "+591": { minLength: 8, maxLength: 8, pattern: /^[67]\d{7}$/, errorMsg: "8 digits" },
  "+592": { minLength: 7, maxLength: 7, pattern: /^6\d{6}$/, errorMsg: "7 digits" },
  "+593": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+595": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+597": { minLength: 7, maxLength: 7, pattern: /^[78]\d{6}$/, errorMsg: "7 digits" },
  "+598": { minLength: 8, maxLength: 8, pattern: /^9\d{7}$/, errorMsg: "8 digits" },
  "+670": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+673": { minLength: 7, maxLength: 7, pattern: /^[78]\d{6}$/, errorMsg: "7 digits" },
  "+674": { minLength: 7, maxLength: 7, pattern: /^5\d{6}$/, errorMsg: "7 digits" },
  "+675": { minLength: 8, maxLength: 8, pattern: /^7\d{7}$/, errorMsg: "8 digits" },
  "+676": { minLength: 7, maxLength: 7, pattern: /^[78]\d{6}$/, errorMsg: "7 digits" },
  "+677": { minLength: 7, maxLength: 7, pattern: /^7\d{6}$/, errorMsg: "7 digits" },
  "+678": { minLength: 7, maxLength: 7, pattern: /^[57]\d{6}$/, errorMsg: "7 digits" },
  "+679": { minLength: 7, maxLength: 7, pattern: /^[7-9]\d{6}$/, errorMsg: "7 digits" },
  "+680": { minLength: 7, maxLength: 7, pattern: /^7\d{6}$/, errorMsg: "7 digits" },
  "+685": { minLength: 7, maxLength: 10, pattern: /^7\d{6,9}$/, errorMsg: "7-10 digits" },
  "+686": { minLength: 8, maxLength: 8, pattern: /^[67]\d{7}$/, errorMsg: "8 digits" },
  "+688": { minLength: 5, maxLength: 6, pattern: /^[79]\d{4,5}$/, errorMsg: "5-6 digits" },
  "+691": { minLength: 7, maxLength: 7, pattern: /^9\d{6}$/, errorMsg: "7 digits" },
  "+692": { minLength: 7, maxLength: 7, pattern: /^[2-6]\d{6}$/, errorMsg: "7 digits" },
  "+850": { minLength: 8, maxLength: 10, pattern: /^1\d{7,9}$/, errorMsg: "8-10 digits" },
  "+855": { minLength: 8, maxLength: 9, pattern: /^[1-9]\d{7,8}$/, errorMsg: "8-9 digits" },
  "+856": { minLength: 8, maxLength: 10, pattern: /^20\d{6,8}$/, errorMsg: "8-10 digits" },
  "+880": { minLength: 10, maxLength: 10, pattern: /^1\d{9}$/, errorMsg: "10 digits" },
  "+886": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+960": { minLength: 7, maxLength: 7, pattern: /^[79]\d{6}$/, errorMsg: "7 digits" },
  "+961": { minLength: 7, maxLength: 8, pattern: /^[378]\d{6,7}$/, errorMsg: "7-8 digits" },
  "+962": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+963": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+964": { minLength: 10, maxLength: 10, pattern: /^7\d{9}$/, errorMsg: "10 digits" },
  "+965": { minLength: 8, maxLength: 8, pattern: /^[569]\d{7}$/, errorMsg: "8 digits" },
  "+966": { minLength: 9, maxLength: 9, pattern: /^5\d{8}$/, errorMsg: "9 digits" },
  "+967": { minLength: 9, maxLength: 9, pattern: /^7\d{8}$/, errorMsg: "9 digits" },
  "+968": { minLength: 8, maxLength: 8, pattern: /^9\d{7}$/, errorMsg: "8 digits" },
  "+970": { minLength: 9, maxLength: 9, pattern: /^5\d{8}$/, errorMsg: "9 digits" },
  "+971": { minLength: 9, maxLength: 9, pattern: /^5\d{8}$/, errorMsg: "9 digits" },
  "+973": { minLength: 8, maxLength: 8, pattern: /^[36]\d{7}$/, errorMsg: "8 digits" },
  "+974": { minLength: 8, maxLength: 8, pattern: /^[3567]\d{7}$/, errorMsg: "8 digits" },
  "+975": { minLength: 8, maxLength: 8, pattern: /^1\d{7}$/, errorMsg: "8 digits" },
  "+976": { minLength: 8, maxLength: 8, pattern: /^[89]\d{7}$/, errorMsg: "8 digits" },
  "+977": { minLength: 10, maxLength: 10, pattern: /^9\d{9}$/, errorMsg: "10 digits" },
  "+992": { minLength: 9, maxLength: 9, pattern: /^9\d{8}$/, errorMsg: "9 digits" },
  "+993": { minLength: 8, maxLength: 8, pattern: /^6\d{7}$/, errorMsg: "8 digits" },
  "+994": { minLength: 9, maxLength: 9, pattern: /^[5-7]\d{8}$/, errorMsg: "9 digits" },
  "+995": { minLength: 9, maxLength: 9, pattern: /^5\d{8}$/, errorMsg: "9 digits" },
  "+996": { minLength: 9, maxLength: 9, pattern: /^[57]\d{8}$/, errorMsg: "9 digits" },
  "+998": { minLength: 9, maxLength: 9, pattern: /^[89]\d{8}$/, errorMsg: "9 digits" }
};

    const validation = countryValidation[countryCode];

    if (validation) {
      // Check length
      if (cleanNumber.length < validation.minLength) {
        return {
          isValid: false,
          error: `Number too short. ${validation.errorMsg}`,
        };
      }
      if (cleanNumber.length > validation.maxLength) {
        return {
          isValid: false,
          error: `Number too long. ${validation.errorMsg}`,
        };
      }

      // Check pattern
      if (!validation.pattern.test(cleanNumber)) {
        return { isValid: false, error: validation.errorMsg };
      }
    } else {
      // General validation for countries not specifically listed
      if (cleanNumber.length < 7) {
        return {
          isValid: false,
          error: "Phone number too short (minimum 7 digits)",
        };
      }
      if (cleanNumber.length > 15) {
        return {
          isValid: false,
          error: "Phone number too long (maximum 15 digits)",
        };
      }
    }

    return { isValid: true, error: null };
  };

  const isValidPhoneNumber = (countryCode, phoneNumber) => {
    const validation = validatePhoneNumber(countryCode, phoneNumber);
    return validation.isValid;
  };

  const getValidationError = (countryCode, phoneNumber) => {
    const validation = validatePhoneNumber(countryCode, phoneNumber);
    return validation.error;
  };

  const handleDone = async () => {
    // Validate using separated country code and phone number
    const validationError = getValidationError(
      selectedCountryCode,
      phoneNumber
    );
    if (validationError) {
      toast.error(validationError, {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    // Combine country code with number for storage
    const fullNumber = selectedCountryCode + phoneNumber.replace(/^\s+/, "");

    if (!contactName.trim()) {
      toast.error("Contact name is required", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    setIsLoading(true);
    let response;

    try {
      if (editingContact) {
        response = await EditContact({
          Id: editingContact.Id,
          ContactInfo: fullNumber,
          Category: "PhoneNumber",
          Title: contactName.trim(),
          isPublic: true,
        });
      } else {
        response = await CreateContact({
          UserId: Id,
          ContactInfo: fullNumber,
          Category: "PhoneNumber",
          Title: contactName.trim(),
          isPublic: true,
        });
      }

      localStorage.setItem("isLinksCardVisible", "true");

      setContactName("");
      setPhoneNumber("");
      setContactName("");
      if (clearEditingContact) clearEditingContact();
      setOpenPhoneDialog(false);

      if (response) {
        toast.success(
          editingContact ? "Phone contact updated" : "Phone contact added",
          {
            position: "top-center",
            autoClose: 1000,
          }
        );
        if (fetchProfile) fetchProfile();
      } else {
        toast.error("Error while saving phone contact", {
          position: "top-center",
          autoClose: 1000,
        });
      }
    } catch (error) {
      toast.error("Error while saving phone contact", {
        position: "top-center",
        autoClose: 1000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={openPhoneDialog}
      onClose={() => {
        setPhoneNumber("");
        setContactName("");
        if (clearEditingContact) clearEditingContact();
        setOpenPhoneDialog(false);
      }}
    >
      <DialogTitle>
        {editingContact ? "Edit Phone Contact" : "Add Phone Contact"}
      </DialogTitle>
      <DialogContent>
        <TextField
          name="contactName"
          autoFocus
          margin="dense"
          label="Contact Name"
          type="text"
          fullWidth
          required
          value={contactName}
          onChange={handleContactNameChange}
          helperText={contactName === "" ? "Contact name is required" : ""}
          sx={{ mb: 2 }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin="dense">
              <InputLabel>Country</InputLabel>
              <Select
                value={selectedCountryCode}
                onChange={(e) => setSelectedCountryCode(e.target.value)}
                label="Country"
                sx={{
                  "& .MuiSelect-select": {
                    padding: { xs: "12px 14px", sm: "16.5px 14px" },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
                renderValue={(value) => {
                  const country = countryCodes.find((c) => c.code === value);
                  return country ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: 0.5, sm: 1 },
                        minWidth: 0,
                      }}
                    >
                      <img
                        src={country.flag}
                        alt={country.country}
                        style={{
                          width: 20,
                          height: 15,
                          flexShrink: 0,
                        }}
                      />
                      <span
                        style={{
                          fontSize: "inherit",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {value}
                      </span>
                    </Box>
                  ) : (
                    value
                  );
                }}
              >
                {countryCodes.map((country, index) => (
                  <MenuItem
                    key={`${country.code}-${index}`}
                    value={country.code}
                    sx={{
                      padding: { xs: "8px 16px", sm: "6px 16px" },
                      minHeight: { xs: "48px", sm: "auto" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                        minWidth: 0,
                      }}
                    >
                      <img
                        src={country.flag}
                        alt={country.country}
                        style={{
                          width: 20,
                          height: 15,
                          flexShrink: 0,
                        }}
                      />
                      <span
                        style={{
                          fontWeight: 500,
                          flexShrink: 0,
                        }}
                      >
                        {country.code}
                      </span>
                      <span
                        style={{
                          fontSize: "0.875rem",
                          color: "#666",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {country.country}
                      </span>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              name="PhoneNumber"
              margin="dense"
              label="Phone Number"
              type="tel"
              fullWidth
              required
              value={phoneNumber}
              onChange={(e) =>
                setPhoneNumber(e.target.value.replace(/[^\d\s\-\(\)]/g, ""))
              }
              error={
                phoneNumber !== "" &&
                !isValidPhoneNumber(selectedCountryCode, phoneNumber)
              }
              helperText={
                phoneNumber === ""
                  ? "Phone number is required"
                  : phoneNumber !== "" &&
                    !isValidPhoneNumber(selectedCountryCode, phoneNumber)
                  ? getValidationError(selectedCountryCode, phoneNumber)
                  : "✓ Valid phone number"
              }
              placeholder="234 567 8900"
              inputProps={{
                maxLength: 15,
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: { xs: "16px", sm: "1rem" }, // Prevents zoom on iOS
                  padding: { xs: "12px 14px", sm: "16.5px 14px" },
                },
                "& .MuiFormHelperText-root": {
                  fontSize: { xs: "0.75rem", sm: "0.75rem" },
                  marginTop: { xs: "4px", sm: "3px" },
                },
              }}
            />
          </Grid>
        </Grid>

        {/* Preview of full number */}
        {phoneNumber && (
          <Box
            sx={{
              mt: { xs: 2, sm: 1 },
              mb: { xs: 2, sm: 1 },
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
            }}
          >
            <Chip
              label={`Full Number: ${selectedCountryCode} ${phoneNumber}`}
              variant="outlined"
              size="small"
              color="primary"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                height: { xs: "28px", sm: "24px" },
                "& .MuiChip-label": {
                  padding: { xs: "0 8px", sm: "0 12px" },
                },
              }}
            />
          </Box>
        )}
        {/* Hints and Tips Section */}
        <Box
          mt={2}
          p={2}
          sx={{
            backgroundColor: "#f0f0f0",
            borderRadius: "5px",
          }}
        >
          <Typography variant="subtitle1" color="textPrimary">
            Tips for Adding Phone Contact
          </Typography>
          <Typography variant="body2" color="textSecondary">
            - Give your contact a descriptive name (e.g., "Work Phone",
            "Personal Phone")
          </Typography>
          <Typography variant="body2" color="textSecondary">
            - Enter the phone number without spaces, dashes, or symbols
          </Typography>
          <Typography variant="body2" color="textSecondary">
            - Include the country code if needed (e.g., +1 for the US)
          </Typography>
          <Typography variant="body2" color="textSecondary">
            - You can add multiple phone contacts with different names
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setContactName("");
            setPhoneNumber("");
            setContactName("");
            if (clearEditingContact) clearEditingContact();
            setOpenPhoneDialog(false);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDone}
          disabled={
            phoneNumber === "" ||
            !isValidPhoneNumber(selectedCountryCode, phoneNumber) ||
            contactName.trim() === "" ||
            isLoading
          }
        >
          {isLoading ? "Saving..." : editingContact ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhoneLinkDialog;
